<template>
  <a-drawer
    :closable="true"
    :maskClosable="true"
    :title="title"
    :visible="visible"
    @close="close"
    placement="right"
    style="overflow: auto;padding-bottom: 53px;"
    width="650"
  >
    <a-form>
      <div class="flex items-center">
        <div class="w-100px">角色首页：</div>
        <div class="w-200px">
          <a-input class v-model="roleIndexPage" />
        </div>
      </div>
      <a-form-item label="所拥有的权限">
        <a-tree
          :checkedKeys="checkedKeys"
          :checkStrictly="checkStrictly"
          :expandedKeys="expandedKeysss"
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          @check="onCheck"
          @expand="onExpand"
          @select="onTreeNodeSelect"
          checkable
        >
          <span slot="hasDatarule" slot-scope="{slotTitle,ruleFlag,key:treeKey,children}">
            <!-- {{ slotTitle }} -->
            <a-icon style="margin-left:5px;color: red;" type="align-left" v-if="ruleFlag"></a-icon>
            <a-dropdown :trigger="['contextmenu']">
              <span>{{ slotTitle }}</span>
              <template #overlay>
                <a-menu @click="({ key: menuKey }) => onContextMenuClick(treeKey, menuKey,children)">
                  <a-menu-item key="setting.index">设置首页</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </span>
        </a-tree>
      </a-form-item>
    </a-form>

    <div class="drawer-bootom-button">
      <a-dropdown :trigger="['click']" placement="topCenter" style="float: left">
        <a-menu slot="overlay">
          <a-menu-item @click="switchCheckStrictly(1)" key="1">父子关联</a-menu-item>
          <a-menu-item @click="switchCheckStrictly(2)" key="2">取消关联</a-menu-item>
          <a-menu-item @click="checkALL" key="3">全部勾选</a-menu-item>
          <a-menu-item @click="cancelCheckALL" key="4">取消全选</a-menu-item>
          <a-menu-item @click="expandAll" key="5">展开所有</a-menu-item>
          <a-menu-item @click="closeAll" key="6">合并所有</a-menu-item>
        </a-menu>
        <a-button>
          树操作
          <a-icon type="up" />
        </a-button>
      </a-dropdown>
      <a-popconfirm @confirm="close" cancelText="取消" okText="确定" title="确定放弃编辑？">
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button :loading="loading" @click="handleSubmit(false)" ghost style="margin-right: 0.8rem" type="primary">仅保存</a-button>
      <a-button :loading="loading" @click="handleSubmit(true)" type="primary">保存并关闭</a-button>
    </div>

    <role-datarule-modal ref="datarule"></role-datarule-modal>
  </a-drawer>
</template>
<script>
  import { queryTreeListForRole, queryRolePermission, saveRolePermission } from '@/api/api'
  import RoleDataruleModal from './RoleDataruleModal.vue'
  import { getAction, postAction } from '../../../api/manage'

  export default {
    name: "RoleModal",
    components: {
      RoleDataruleModal
    },
    data () {
      return {
        roleId: "",
        treeData: [],
        defaultCheckedKeys: [],
        checkedKeys: [],
        expandedKeysss: [],
        allTreeKeys: [],
        autoExpandParent: true,
        checkStrictly: true,
        title: "角色权限配置",
        visible: false,
        loading: false,
        selectedKeys: [],
        roleIndexPage: ""
      }
    },
    methods: {
      onTreeNodeSelect (id) {
        if (id && id.length > 0) {
          this.selectedKeys = id
        }
        this.$refs.datarule.show(this.selectedKeys[0], this.roleId)
      },
      onCheck (o) {
        if (this.checkStrictly) {
          this.checkedKeys = o.checked;
        } else {
          this.checkedKeys = o
        }
      },
      show (roleId) {
        this.roleId = roleId
        this.visible = true;
      },
      close () {
        this.reset()
        this.$emit('close');
        this.visible = false;
      },
      onExpand (expandedKeys) {
        this.expandedKeysss = expandedKeys;
        this.autoExpandParent = false
      },
      reset () {
        this.expandedKeysss = []
        this.checkedKeys = []
        this.defaultCheckedKeys = []
        this.loading = false
      },
      expandAll () {
        this.expandedKeysss = this.allTreeKeys
      },
      closeAll () {
        this.expandedKeysss = []
      },
      checkALL () {
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      switchCheckStrictly (v) {
        if (v == 1) {
          this.checkStrictly = false
        } else if (v == 2) {
          this.checkStrictly = true
        }
      },
      handleCancel () {
        this.close()
      },
      handleSubmit (exit) {
        let that = this;
        let params = {
          roleId: that.roleId,
          permissionIds: that.checkedKeys.join(","),
          lastpermissionIds: that.defaultCheckedKeys.join(","),
        };
        that.loading = true;
        console.log("请求参数：", params);
        saveRolePermission(params).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loading = false;
            if (exit) {
              that.close()
            }
          } else {
            that.$message.error(res.message);
            that.loading = false;
            if (exit) {
              that.close()
            }
          }
          this.loadData();
        })
      },
      async loadData () {

        queryTreeListForRole().then((res) => {
          this.treeData = res.result.treeList
          this.allTreeKeys = res.result.ids
          queryRolePermission({ roleId: this.roleId }).then((res) => {
            this.checkedKeys = [...res.result];
            this.defaultCheckedKeys = [...res.result];
            this.expandedKeysss = this.allTreeKeys;
          })
        })
      },
      loadDefaultIndex () {

        getAction('/sys/permission/getRoleDefaultIndex', { roleId: this.roleId }).then(res => {
          if (res.success) {
            this.roleIndexPage = res?.result?.meta.title ?? ''
            this.$store.dispatch('changeDefaultHome', res.result)
          }
        })
      },
      onContextMenuClick (treeKey, menuKey, children) {
        console.log(`treeKey: ${treeKey}, menuKey: ${menuKey},childrenLength:${children}`);
        if (children) {
          this.$message.error('当前菜单有下级页面')
          return
        }

        postAction('/sys/permission/setIsDefaultHome', {
          roleId: this.roleId,
          permissionId: treeKey,
          isDefaultHome: '1'
        }).then(res => {
          if (res.success) {
            this.$message.success('设置成功！')
            this.loadDefaultIndex()
          }
        })
      },



    },
    watch: {
      visible () {
        if (this.visible) {
          this.loadDefaultIndex()
          this.loadData();
        }
      }
    }
  }

</script>
<style lang="less" scoped>
  .drawer-bootom-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>